import React from 'react'
import { ResponsiveTableRow } from '@fs/zion-ui'
import { Column1Skeleton, Column2Skeleton, Column3Skeleton } from './Columns'

const RowSkeleton = () => (
  <ResponsiveTableRow column1={<Column1Skeleton />} column2={<Column2Skeleton />} column3={<Column3Skeleton />} />
)

export default function RowSkeletons({ count }) {
  return Array.from({ length: count }, (_, index) => <RowSkeleton key={`skeleton_${index}`} />)
}
